import ThoughtBubble from '@/components/ThoughtBubble';

interface Bubble {
  id: string;
  rubric_driver: string;
  title: string;
  body: string;
  anchor_hint: string;
}

interface WhyChangesSectionProps {
  bubbles: Bubble[];
}

export function WhyChangesSection({ bubbles }: WhyChangesSectionProps) {
  if (!bubbles || bubbles.length === 0) return null;

  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-foreground flex items-center gap-2">
        Why These Changes Help
      </h3>
      <div className="grid gap-3">
        {bubbles.map((bubble, index) => (
          <ThoughtBubble
            key={bubble.id}
            title={bubble.title}
            body={bubble.body}
            rubricDriver={bubble.rubric_driver}
            index={index}
          />
        ))}
      </div>
    </div>
  );
}
